module.exports = __webpack_public_path__ + "img/tpc-9.c0d142a9.jpg";